// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class DocumentLinkModel {
    static getAttributeTypeMap() {
        return DocumentLinkModel.attributeTypeMap;
    }
}
DocumentLinkModel.discriminator = undefined;
DocumentLinkModel.attributeTypeMap = [
    {
        "name": "childDocumentId",
        "baseName": "childDocumentId",
        "type": "number"
    },
    {
        "name": "sequenceNumber",
        "baseName": "sequenceNumber",
        "type": "number"
    }
];
//# sourceMappingURL=documentLinkModel.js.map